<app-contact-documents [contact]="contact"></app-contact-documents>
<app-contact-ophtalmo-treatment [contact]="contact"></app-contact-ophtalmo-treatment>
